import type { Product } from 'product/types'

export function getProductLinkLabel(
	product: Product,
	selectedColorLabel: string
) {
	return `${product.name}, ${selectedColorLabel}. Ref: ${product.id}.`
}
